module.exports = __webpack_public_path__ + "img/30.e91c4636.jpg";